<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="detailsContent">
      <div class="detailsTitle">
        <div class="detailsWrap"></div>
        <p>商品庫存</p>
      </div>

      <el-form>
        <el-form-item class="goodsAdd" label="SKU ：">
          <div class="goodsWrap" v-for="(item, index) in skuList" :key="index">
            <div class="goodsItem" v-if="skuType">
              <!-- <input v-if="item.masterFlag" v-model="item.attrSymbolPath" disabled class="el-input__inner" type="text"> -->
              <input
                v-if="status === '售賣中'"
                v-model="item.attrSymbolPath"
                disabled
                class="el-input__inner"
                type="text"
              />

              <input
                @change="isMasterSame()"
                v-else
                v-model="item.attrSymbolPath"
                class="el-input__inner"
                type="text"
              />
            </div>
            <span
              v-show="index !== 0 && status !== '售賣中'"
              class="delBtn"
              @click="delGoodsItem(index, skuList)"
              >删除</span
            >
          </div>

          <div
            v-if="skuType"
            v-show="status !== '售賣中' && skuList.length < 6"
            class="addDetail"
            @click="addSku()"
          >
            添加
          </div>
          <div class="skuTableWrap">
            <table class="skuTable">
              <thead>
                <tr>
                  <th v-if="skuType">商品尺寸</th>
                  <th>價格(TWD)</th>
                  <th v-if="skuList[0].vipRealPrice">會員價(TWD)</th>
                  <th>價格(CNY)</th>
                  <th v-if="skuList[0].vipPriceRmb">會員價(CNY)</th>
                  <th>總庫存</th>
                  <th v-show="status !== '即將售賣'">已成交</th>
                  <th v-show="status === '售賣中'">已鎖定未付款</th>
                  <th v-show="status === '售賣中'">剩餘庫存</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in skuList" :key="index">
                  <td v-if="skuType" style="max-width: 300px;white-space: pre-wrap; word-wrap: break-word;">{{ item.attrSymbolPath }}</td>
                  <td>
                    <!-- 即将售卖和已下架的新增sku的价格可以修改 -->
                    <input
                      v-if="
                        (status === '即將售賣' || status === '已下架') &&
                          item.skuType === 'new'
                      "
                      type="text"
                      v-model="item.realPrice"
                    />
                    <span v-else>{{ item.realPrice }}</span>
                  </td>
                  <td v-if="item.vipRealPrice">
                    <!-- 即将售卖和已下架的新增sku的价格可以修改 -->
                    <input
                      v-if="
                        (status === '即將售賣' || status === '已下架') &&
                          item.skuType === 'new'
                      "
                      type="text"
                      v-model="item.vipRealPrice"
                    />
                    <span v-else>{{ item.vipRealPrice }}</span>
                  </td>
                  <td>
                    <!-- 即将售卖和已下架的新增sku的价格可以修改 -->
                    <input
                      v-if="
                        (status === '即將售賣' || status === '已下架') &&
                          item.skuType === 'new'
                      "
                      type="text"
                      v-model="item.priceRmb"
                    />
                    <span v-else>{{ item.priceRmb }}</span>
                  </td>
                  <td v-if="item.vipPriceRmb">
                    <!-- 即将售卖和已下架的新增sku的价格可以修改 -->
                    <input
                      v-if="
                        (status === '即將售賣' || status === '已下架') &&
                          item.skuType === 'new'
                      "
                      type="text"
                      v-model="item.vipPriceRmb"
                    />
                    <span v-else>{{ item.vipPriceRmb }}</span>
                  </td>
                  <td>
                    <!-- 即将售卖和已下架的新增sku的库存可以修改 -->
                    <input
                      v-if="
                        (status === '即將售賣' || status === '已下架') &&
                          item.skuType === 'new'
                      "
                      type="text"
                      v-model="item.realTotal"
                    />
                    <span v-else>{{ item.realTotal }}</span>
                  </td>
                  <td v-show="status !== '即將售賣'">{{ item.bargain }}</td>
                  <!-- 已成交，售卖中和已下架情况下展示 -->
                  <td v-show="status === '售賣中'">
                    {{ item.lockDzfStock }}
                  </td>
                  <!-- 已锁定 -->
                  <td v-show="status === '售賣中'">{{ item.residueStock }}</td>
                  <!-- 剩余库存 -->
                  <td>
                    <div
                      v-if="
                        (status === '即將售賣' || status === '已下架') &&
                          item.skuType === 'new'
                      "
                    >
                      <span style="color:#666;">无</span>
                    </div>
                    <div v-else>
                      <span
                        v-show="status === '即將售賣'"
                        class="operation"
                        @click="
                          changePrice(
                            item.realPrice,
                            item.priceRmb,
                            item.skuId,
                            item.vipPriceRmb,
                            item.vipRealPrice
                          )
                        "
                        >修改價格</span
                      >
                      <span
                        v-if="status === '售賣中'"
                        class="operation"
                        @click="
                          changeStock(
                            item.realTotal,
                            item.bargain,
                            item.lockDzfStock,
                            item.residueStock,
                            item.skuId
                          )
                        "
                        >添加庫存</span
                      >
                      <span
                        v-else
                        class="operation"
                        @click="
                          changeStock(
                            item.realTotal,
                            item.bargain,
                            item.lockDzfStock,
                            item.residueStock,
                            item.skuId
                          )
                        "
                        >修改總庫存</span
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-form-item>
      </el-form>
      <div class="bottomBtn">
        <div class="btn" @click="saveInventory()" v-show="saveShowFlag">
          保存
        </div>
        <div class="btn" @click="refreshInventory()" v-show="!saveShowFlag">
          刷新
        </div>
      </div>
    </div>
    <!-- 修改价格或者库存的弹窗 -->
    <div v-if="propFlag" class="propWrap">
      <div class="prop-content mobile_show">
        <i class="iconfont icon-close fr hand" @click="closeProp()"></i>
        <p class="prop-title normal_font">提示</p>

        <div class="flexCenter" v-if="changePriceFlag">
          <el-form>
            <el-form-item label="原價格 ：">
              <div>
                <input
                  type="text"
                  v-model="realPrice"
                  disabled
                  class="el-input__inner"
                />TWD
              </div>
              <div>
                <input
                  type="text"
                  v-model="priceRmb"
                  disabled
                  class="el-input__inner"
                />CNY
              </div>
            </el-form-item>
            <el-form-item label="修改價格 ：">
              <div>
                <input
                  type="text"
                  v-model="editRealPrice"
                  class="el-input__inner"
                />TWD
              </div>
              <div>
                <input
                  type="text"
                  v-model="editPriceRmb"
                  class="el-input__inner"
                />CNY
              </div>
            </el-form-item>
          </el-form>
          <el-form v-if="vipPriceRmb&&vipRealPrice">
            <el-form-item label="原會員價格 ：">
              <div>
                <input
                  type="text"
                  v-model="vipRealPrice"
                  disabled
                  class="el-input__inner"
                />TWD
              </div>
              <div>
                <input
                  type="text"
                  v-model="vipPriceRmb"
                  disabled
                  class="el-input__inner"
                />CNY
              </div>
            </el-form-item>
            <el-form-item label="修改會員價格 ：">
              <div>
                <input
                  type="text"
                  v-model="editVipRealPrice"
                  class="el-input__inner"
                />TWD
              </div>
              <div>
                <input
                  type="text"
                  v-model="editVipPriceRmb"
                  class="el-input__inner"
                />CNY
              </div>
            </el-form-item>
          </el-form>
        </div>

        <div class="changeWrap" v-if="changeStockFlag">
          <el-form>
            <el-form-item label="現總庫存 ：">
              <input
                type="text"
                v-model="stock"
                disabled
                class="el-input__inner"
              />
            </el-form-item>
            <el-form-item label="增加/減去庫存 ：">
              <input
                type="text"
                v-model="editStock"
                class="el-input__inner"
                @blur="stockInputBlur()"
              />
              <!-- <span style="display:block;color:rgba(41,41,41,0.6)">修改值不得小於{{minStock}}</span> -->
            </el-form-item>
            <p>負數為減去庫存，例：-10為在剩餘庫存中減去10個庫存</p>
          </el-form>
        </div>

        <div class="bottomBtn">
          <div class="btn borderBtn" @click="closeProp()">取消</div>
          <div class="btn hand new_btn" @click="changeItem()">確認</div>
        </div>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "商城  /  商品列表",
      navtitle: "编辑庫存",
      id: this.$route.query.id,
      url: this.$route.query.url,
      status: "", // 商品状态
      skuList: [
        {
          goodsId: 0,
          skuId: 0,
          attrSymbolPath: "", // 商品sku
          realPrice: "", // 价格
          realTotal: "", // 总库存
          bargain: "", // 已成交
          lockDzfStock: "", // 已锁定未付款
          residueStock: "", // 剩余库存
          turn: 0
        }
      ],
      propFlag: false,
      changePriceFlag: false,
      changeStockFlag: false,
      realPrice: "", // 原twd价格
      priceRmb: "", // 原rmb价格
      vipPriceRmb: "", //原会员rmb价格
      vipRealPrice: "", //原会员twd价格
      stock: "", // 原库存
      minStock: "", // 可以更改的最小库存
      editRealPrice: "", // 修改后twd的价格
      editPriceRmb: "", // 修改后rmb的价格
      editVipPriceRmb: "", // 修改后会员rmb的价格
      editVipRealPrice: "", // 修改后会员twd的价格
      editStock: "", // 修改后的库存
      itemSkuId: "",
      validList: [], // 已经删除的sku的skuid
      require: true, // 禁止用户连续点击，发出多次请求接口
      skuRequire: true, // 禁止用户连续点击编辑保存sku
      masterSkuList: [], //原始skuList
      saveShowFlag: false,
      dialogVisible: false,
      skuType: 1
    };
  },
  created() {
    this.initInventory();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取库存信息
    initInventory() {
      let _this = this;
      _this
        .$get(
          `/request/mall/findSKuById?goodsId=${_this.id}`,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            if (res.data.length !== 0) {
              switch (res.data[0].status) {
                case 0:
                  _this.status = "已售完";
                  break;
                case 1:
                  _this.status = "售賣中";
                  break;
                case 2:
                  _this.status = "即將售賣";
                  break;
                case "3":
                  _this.status = "已下架";
                  break;
              }
              // for(var i in res.data){
              //   // _this.validList.push(res.data[i].skuId)// skuId

              // }

              // res.data.forEach(v => {
              //   v.masterFlag = true;
              // });

              _this.skuList = res.data;

              _this.skuType = res.data[0].skuType;

              localStorage.setItem("masterSkuList", JSON.stringify(res.data));
            }
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    // 添加sku
    addSku() {
      let length = this.skuList.length;
      this.skuList.push({
        goodsId: this.id,
        attrSymbolPath: "",
        realPrice: "",
        priceRmb: "",
        realTotal: "",
        bargain: "",
        lockDzfStock: "",
        residueStock: "",
        turn: Number(this.skuList[length - 1].turn) + 1,
        skuType: "new",
        skuId: ""
      });
      this.isMasterSame();
    },
    // 判斷sku是否與原來一致
    isMasterSame() {
      let list = JSON.parse(localStorage.getItem("masterSkuList"));
      if (JSON.stringify(this.skuList) === JSON.stringify(list)) {
        this.saveShowFlag = false;
      } else {
        this.saveShowFlag = true;
      }
    },
    // 刪除sku
    delGoodsItem(index, itemList) {
      if (this.skuList[index].skuId !== "") {
        this.validList.push(this.skuList[index].skuId);
      }
      itemList.splice(index, 1);
      this.isMasterSame();
    },
    // 修改价格
    changePrice(price, priceRmb, skuId, vipPriceRmb, vipRealPrice) {
      this.realPrice = price;
      this.priceRmb = priceRmb;
      this.itemSkuId = skuId;
      this.vipPriceRmb = vipPriceRmb;
      this.vipRealPrice = vipRealPrice;
      this.editRealPrice = "";
      this.editPriceRmb = "";
      this.editVipPriceRmb = "";
      this.editVipRealPrice = "";
      this.propFlag = true;
      this.changePriceFlag = true;
    },

    // 修改总库存
    changeStock(stock, completed, locked, residueStock, skuId) {
      let _this = this;
      _this.stock = stock;
      if (_this.status === "已售完") {
        _this.dialogVisible = true;
        _this.$propMessage("已售完的商品不可以修改總庫存", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.status === "售賣中") {
        // 售卖中，总库存不得小于已成交+已锁定
        if (residueStock != 0) {
          _this.dialogVisible = true;
          _this.$propMessage(
            "售賣中還有剩餘庫存未清空，不可以修改總庫存",
            "error",
            function() {
              _this.dialogVisible = false;
            }
          );
          return false;
        } else {
          _this.minStock = Number(Number(completed) + Number(locked));
        }
      } else if (_this.status === "已下架") {
        // 已下架，总库存不能小于已成交数量
        _this.minStock = Number(completed);
      }
      _this.itemSkuId = skuId;
      _this.editStock = "";

      _this.propFlag = true;
      _this.changeStockFlag = true;
    },

    // 提交修改价格或者库存
    changeItem() {
      let _this = this;
      if (_this.changePriceFlag) {
        if (_this.editRealPrice === "") {
          _this.dialogVisible = true;
          _this.$propMessage("請輸入修改後的TWD價格", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
        if (_this.editPriceRmb === "") {
          _this.dialogVisible = true;
          _this.$propMessage("請輸入修改後的CNY價格", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
       if(_this.vipPriceRmb&&_this.vipRealPrice){
         if (_this.editVipRealPrice === "") {
          _this.dialogVisible = true;
          _this.$propMessage("請輸入修改後的會員TWD價格", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
        if (_this.editVipPriceRmb === "") {
          _this.dialogVisible = true;
          _this.$propMessage("請輸入修改後的會員CNY價格", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
       }

        // 修改价格
        if (_this.require) {
          _this.require = false;
          if (_this.status === "即將售賣") {
            let priceParam = {
              goodsId: _this.id,
              skuId: _this.itemSkuId,
              realPrice: _this.editRealPrice,
              priceRmb: _this.editPriceRmb,
              vipRealPrice: _this.editVipRealPrice?_this.editVipRealPrice:null,
              vipPriceRmb: _this.editVipPriceRmb?_this.editVipPriceRmb:null,
              onOff: 666
            };
            _this
              .$post(
                "/request/mall/updateSkuBySkuId",
                priceParam,
                this.$GLOBAL.jsonConfig
              )
              .then(res => {
                _this.dialogVisible = true;
                if (res.code === "60005") {
                  _this.$propMessage("編輯价格成功", "success", function() {
                    _this.dialogVisible = false;
                    _this.editStock = "";
                    _this.closeProp();
                    _this.initInventory();
                  });

                  setTimeout(() => {
                    _this.require = true;
                  }, 5000);
                } else {
                  _this.$propMessage(res.message, "success", function() {
                    _this.dialogVisible = false;
                  });
                }
              });
          }
        }
      } else if (_this.changeStockFlag) {
        // 修改库存
        if (_this.editStock === "") {
          if (_this.status === "售賣中") {
            _this.dialogVisible = true;
            _this.$propMessage("請輸入增加的庫存", "error", function() {
              _this.dialogVisible = false;
            });
          } else {
            _this.dialogVisible = true;
            _this.$propMessage("請輸入修改後的總庫存", "error", function() {
              _this.dialogVisible = false;
            });
          }
          return false;
        }

        // if (_this.editStock < _this.minStock) {
        //   _this.editStock = _this.minStock;
        // }

        if (_this.require) {
          _this.require = false;
          console.log(+_this.stock + Number(_this.editStock));
          if (+_this.stock + Number(_this.editStock) < 0) {
            _this.dialogVisible = true;
            _this.$propMessage("减少库存后不能小于0", "error", function() {
              _this.dialogVisible = false;
            });
            setTimeout(() => {
              _this.require = true;
            }, 5000);
            return false;
          }
          let stockParam = {
            goodsId: _this.id,
            skuId: _this.itemSkuId,
            maxBuyNum: Number(_this.editStock),
            onOff: 666
          };
          _this
            .$post(
              "/request/mall/updateSkuBySkuId",
              stockParam,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (_this.status === "售賣中") {
                if (res.code === "60006") {
                  _this.$propMessage("編輯庫存成功", "success", function() {
                    _this.dialogVisible = false;
                    _this.editStock = "";
                    _this.closeProp();
                    _this.initInventory();
                  });

                  setTimeout(() => {
                    _this.require = true;
                  }, 5000);
                } else {
                  _this.$propMessage(res.message, "error", function() {
                    _this.dialogVisible = false;
                  });
                }
              } else {
                if (res.code === "60006") {
                  _this.$propMessage("編輯庫存成功", "success", function() {
                    _this.dialogVisible = false;
                    _this.editStock = "";
                    _this.closeProp();
                    _this.initInventory();
                  });

                  setTimeout(() => {
                    _this.require = true;
                  }, 5000);
                } else {
                  _this.$propMessage(res.message, "error", function() {
                    _this.dialogVisible = false;
                  });
                }
              }
            });
        }
      }
    },
    // 总库存输入框聚焦事件
    stockInputBlur() {
      if (this.editStock.substr(0, 1) === "-") {
        this.editStock = this.editStock.replace(/^(0+)|[^\d]+/g, "") * -1;
      } else {
        this.editStock = this.editStock.replace(/^(0+)|[^\d]+/g, "");
      }
      // this.editStock = this.editStock < this.minStock ? this.minStock : this.editStock;
    },

    // 保存编辑sku
    saveInventory() {
      let _this = this;
      // 只有即将售卖和已下架状态下才可以修改sku，售卖中不可修改sku
      if (_this.skuRequire) {
        if (_this.status !== "售賣中") {
          _this
            .$confirm("是否確定修改該商品信息?", "提示信息", {
              confirmButtonText: "確認",
              cancelButtonText: "取消",
              center: true,
              closeOnClickModal: false
            })
            .then(() => {
              // 判斷新增sku價格和庫存是否為空
              for (var i in _this.skuList) {
                if (
                  _this.skuList[i].attrSymbolPath === "" ||
                  _this.skuList[i].realPrice === "" ||
                  _this.skuList[i].priceRmb === "" ||
                  _this.skuList[i].realTotal === "" ||
                  _this.$getCaption(_this.skuList[i].realPrice) ||
                  _this.$getCaption(_this.skuList[i].realTotal)
                ) {
                  _this.dialogVisible = true;
                  _this.$propMessage(
                    "商品SKU不能有選項為空或者含有非法字符",
                    "error",
                    function() {
                      _this.dialogVisible = false;
                    }
                  );
                  return false;
                }
              }
              _this.skuRequire = false;
              let list = [];
              for (let i = 0; i < _this.skuList.length; i++) {
                list.push({
                  goodsId: _this.id,
                  attrSymbolPath: _this.skuList[i].attrSymbolPath,
                  realPrice: _this.skuList[i].realPrice,
                  priceRmb: _this.skuList[i].priceRmb,
                  realTotal: _this.skuList[i].realTotal,
                  turn: _this.skuList[i].turn,
                  skuId: _this.skuList[i].skuId
                });
              }

              let param = {
                goodsId: _this.id,
                validList: _this.validList,
                skuDtoList: list
                // skuId: _this.skuList[0].skuId,
              };
              console.log(param);

              _this
                .$post(
                  "/request/mall/updateSkuBySkuId",
                  param,
                  _this.$GLOBAL.jsonConfig
                )
                .then(res => {
                  _this.dialogVisible = true;
                  if (res.code === "00000") {
                    _this.$propMessage("修改成功", "success", function() {
                      _this.$router.push(_this.url);
                      _this.dialogVisible = false;
                    });

                    setTimeout(() => {
                      _this.skuRequire = true;
                    }, 10000);
                  } else {
                    _this.$propMessage(res.message, "error", function() {
                      _this.dialogVisible = false;
                    });
                  }
                });
            })
            .catch(() => {});
        }
      }
    },

    // 刷新库存
    refreshInventory() {
      this.initInventory();
    },

    // 关闭弹窗
    closeProp() {
      this.propFlag = false;
      this.changePriceFlag = false;
      this.changeStockFlag = false;
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>
<style lang="less" scoped>
input:disabled {
  background: #eee;
}

.contentDetails {
  position: relative;

  .detailsContent {
    .goodsWrap {
      display: flex;
      margin-bottom: 0.1rem;

      input:disabled {
        background: rgba(242, 240, 247, 0.5);
        border-color: rgba(147, 142, 164, 0.5);
        color: rgba(147, 142, 164, 0.5);
      }

      .goodsItem {
        input {
          width: 2rem;
        }
      }

      .goodsItemLeft {
        margin-right: 0.1rem;

        input {
          width: 2rem;
        }
      }

      .goodsItemRight {
        margin-left: 0.1rem;

        input {
          width: 3rem;
        }
      }

      .delBtn {
        display: inline-block;
        margin: 0 0.1rem 0 0.24rem;
        cursor: pointer;
        line-height: 40px;
        color: rgba(108, 61, 234, 1);
      }
    }

    .addDetail {
      width: 0.8rem;
      height: 0.36rem;
      line-height: 0.36rem;
      text-align: center;
      background: rgba(242, 240, 247, 1);
      color: rgba(147, 142, 164, 1);
      border-radius: 0.04rem;
      cursor: pointer;
    }

    .skuTableWrap {
      @media screen and (max-width: 768px) {
        width: 4rem;
        overflow: auto;
      }

      .skuTable {
        margin-top: 0.4rem;

        td {
          span.operation {
            color: #6c3dea;
            cursor: pointer;
          }
        }
      }
    }
  }

  .propWrap {
    .icon-close {
      margin: 10px;
    }

    .changeWrap {
      display: flex;
      justify-content: center;
      align-items: center;

      input {
        width: 2rem;
        display: inline-block;
        margin-right: 0.2rem;
      }
    }
    .flexCenter {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      input {
        width: 2rem;
        display: inline-block;
        margin-right: 0.2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/market/marketGoods/editorialInventory.vue